/**
 * DialogBody — Scrollable content area for Dialog
 *
 * Wraps children in a ScrollView with standard padding.
 * Use for form fields, text content, selection lists, etc.
 */
import type { ReactNode } from 'react'
import { styled, ScrollView } from 'tamagui'

const DialogBodyFrame = styled(ScrollView, {
  name: 'DialogBody',
  px: '$md',
  py: '$sm',
})

interface DialogBodyProps {
  children: ReactNode
}

export function DialogBody({ children }: DialogBodyProps) {
  return (
    <DialogBodyFrame>
      {children}
    </DialogBodyFrame>
  )
}
